'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from {\n      transform: translate3d(0, -100%, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n'], ['\n  from {\n      transform: translate3d(0, -100%, 0);\n      visibility: visible;\n    }\n\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation-name: ', ';\n'], ['\n  animation-name: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _BaseAnimation = require('../BaseAnimation');

var _BaseAnimation2 = _interopRequireDefault(_BaseAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SlideInDownAnimation = (0, _styledComponents.keyframes)(_templateObject);

var SlideInDown = (0, _styledComponents2.default)(_BaseAnimation2.default)(_templateObject2, SlideInDownAnimation);

exports.default = SlideInDown;


//////////////////
// WEBPACK FOOTER
// ./~/animate-css-styled-components/lib/Slide/InDown.js
// module id = 545
// module chunks = 95715928098905 168707334958949